<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">

        <tyl-kendo-pdf-export [keepTogether]="'.expandedDetail'" class="tylKendoPdf">
            <div class="flex-header">
                <student-header [pageTitle]="'Graduation Plan Progress'" [showYearSelector]="true"
                    [disableYearSelect]="true"></student-header>
            </div>

            <div class="flex-content">

                <!-- Header Table -->
                <table width="100%">
                    <tr style="line-height:25px;">
                        <td style="color:gray; text-align: left" width="40%">
                            <span translate style="font-weight: bold;">Primary Graduation Plan</span>&nbsp;
                            <p style="color:black; display:inline; padding-left:10px;">{{primayGradPlan.GradPlanName}}</p>
                        </td>
                        <td style="color:gray;" width="30%">
                            <span translate style="font-weight: bold;">Declaration Date</span>&nbsp;
                            <p style="color:black; display:inline; padding-left:10px;">{{primayGradPlan.DeclarationDate}}
                            </p>
                        </td>
                        <td style="color:gray;" width="30%">
                            <span translate style="font-weight: bold;">Parent Signature Received</span>&nbsp;
                            <p style="color:black; display:inline; padding-left:10px;">{{primayGradPlan.ParentSigReceived}}
                            </p>
                        </td>
                    </tr>
                    <tr style="line-height:25px;">
                        <td style="color:gray;" height="30px">
                            <span translate style="font-weight: bold;">Graduation Year</span>&nbsp;
                            <p style="color:black; display:inline; padding-left:10px;">{{primayGradPlan.GraduationYear}}</p>
                        </td>
                        <td style="color:gray;" colspan="2">
                            <span translate style="font-weight: bold;">Graduation Basis</span>&nbsp;
                            <p style="color:black; display:inline; padding-left:10px;">{{primayGradPlan.GraduationBasis}}
                            </p>
                        </td>
                    </tr>
                </table>
                <hr>

                <!-- Plan Header -->
                <mat-table class="graduationPlanTable">

                    <!-- More -->
                    <ng-container matColumnDef="more">
                        <mat-header-cell *matHeaderCellDef translate>
                            More
                        </mat-header-cell>
                    </ng-container>

                    <!-- Graduation Plan -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef translate>
                            Graduation Plan/Subject Area/Credit Code/Course
                        </mat-header-cell>
                    </ng-container>

                    <!-- Required -->
                    <ng-container matColumnDef="required">
                        <mat-header-cell *matHeaderCellDef translate>
                            Required
                        </mat-header-cell>
                    </ng-container>

                    <!-- Attempted -->
                    <ng-container matColumnDef="attempted">
                        <mat-header-cell *matHeaderCellDef translate>
                            Attempted
                        </mat-header-cell>
                    </ng-container>

                    <!-- Earned -->
                    <ng-container matColumnDef="earned">
                        <mat-header-cell *matHeaderCellDef translate>
                            Earned
                        </mat-header-cell>
                    </ng-container>

                    <!-- Current -->
                    <ng-container matColumnDef="current">
                        <mat-header-cell *matHeaderCellDef translate>
                            Current
                        </mat-header-cell>
                    </ng-container>

                    <!-- Requested -->
                    <ng-container matColumnDef="requested">
                        <mat-header-cell *matHeaderCellDef translate>
                            Requested
                        </mat-header-cell>
                    </ng-container>

                    <!-- Over -->
                    <ng-container matColumnDef="over">
                        <mat-header-cell *matHeaderCellDef translate>
                            Over
                        </mat-header-cell>
                    </ng-container>

                    <!-- Need -->
                    <ng-container matColumnDef="need">
                        <mat-header-cell *matHeaderCellDef translate>
                            Need
                        </mat-header-cell>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef translate>
                            Status
                        </mat-header-cell>
                    </ng-container>

                    <!-- Row Definitions -->
                    <mat-header-row *matHeaderRowDef="headerTableColumns"></mat-header-row>
                </mat-table>

                <!-- Graduation Plans Table -->
                <mat-table class="graduationPlanTable" [dataSource]="tableData" multiTemplateDataRows>

                    <!-- More -->
                    <ng-container matColumnDef="more">
                        <mat-cell *matCellDef="let gradPlan">
                            <span *ngIf="gradPlan.getTableData(gpFilterParam).data.length > 0" [ngClass]="{
                            'detail-row-expanded-icon': tableData.checkExpanded(gradPlan),
                            'detail-row-collapsed-icon': !tableData.checkExpanded(gradPlan)
                        }"></span>
                        </mat-cell>
                    </ng-container>

                    <!-- Graduation Plan -->
                    <ng-container matColumnDef="graduationPlan">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.GradPlanName}}
                        </mat-cell>
                    </ng-container>

                    <!-- Required -->
                    <ng-container matColumnDef="required">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Required | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Attempted -->
                    <ng-container matColumnDef="attempted">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Attempted | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Earned -->
                    <ng-container matColumnDef="earned">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Earned | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Current -->
                    <ng-container matColumnDef="current">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Current | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Requested -->
                    <ng-container matColumnDef="requested">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Requested | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Over -->
                    <ng-container matColumnDef="over">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Over | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Need -->
                    <ng-container matColumnDef="need">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Need | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                        </mat-cell>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="status">
                        <mat-cell *matCellDef="let gradPlan">
                            {{gradPlan.Status}}
                        </mat-cell>
                    </ng-container>

                    <!-- Subject Areas -->
                    <ng-container matColumnDef="expandedDetail">
                        <mat-cell *matCellDef="let gradPlan; let j = dataIndex" [attr.colspan]="2" style="width:100%;"
                            class="mat-detail-card">

                            <!-- Subject Areas Table -->
                            <mat-table [dataSource]="gradPlan.getTableData(gpFilterParam)" multiTemplateDataRows
                                class="subjectAreaTable">

                                <!-- More -->
                                <ng-container matColumnDef="more">
                                    <mat-cell *matCellDef="let subjectArea">
                                        <span *ngIf="subjectArea.getTableData(gpFilterParam).data.length > 0" [ngClass]="{
                                        'detail-row-expanded-icon': tableData.checkExpanded(subjectArea),
                                        'detail-row-collapsed-icon': !tableData.checkExpanded(subjectArea)
                                    }"></span>
                                    </mat-cell>
                                </ng-container>

                                <!-- Subject Area -->
                                <ng-container matColumnDef="subjectArea">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.SubjectArea}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Required -->
                                <ng-container matColumnDef="required">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Required | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Attempted -->
                                <ng-container matColumnDef="attempted">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Attempted | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Earned -->
                                <ng-container matColumnDef="earned">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Earned | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Current -->
                                <ng-container matColumnDef="current">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Current | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Requested -->
                                <ng-container matColumnDef="requested">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Requested | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Over -->
                                <ng-container matColumnDef="over">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Over | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Need -->
                                <ng-container matColumnDef="need">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Need | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Status -->
                                <ng-container matColumnDef="status">
                                    <mat-cell *matCellDef="let subjectArea">
                                        {{subjectArea.Status}}
                                    </mat-cell>
                                </ng-container>

                                <!-- Credit Codes -->
                                <ng-container matColumnDef="expandedDetail">
                                    <mat-cell *matCellDef="let subjectArea; let k = dataIndex" [attr.colspan]="2"
                                        style="width:100%;" class="mat-detail-card">

                                        <!-- Credit Codes Table -->
                                        <mat-table [dataSource]="subjectArea.getTableData(gpFilterParam)"
                                            class="creditCodeTable" multiTemplateDataRows>

                                            <!-- More -->
                                            <ng-container matColumnDef="creditCodeTableMore">
                                                <mat-cell *matCellDef="let creditCode">
                                                    <span *ngIf="creditCode.getTableData(gpFilterParam).data.length > 0"
                                                        [ngClass]="{
                                                'detail-row-expanded-icon': tableData.checkExpanded(creditCode),
                                                'detail-row-collapsed-icon': !tableData.checkExpanded(creditCode)
                                            }"></span>
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Credit Code -->
                                            <ng-container matColumnDef="creditCode">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.CreditCode}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Required -->
                                            <ng-container matColumnDef="required">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Required | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Attempted -->
                                            <ng-container matColumnDef="attempted">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Attempted | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Earned -->
                                            <ng-container matColumnDef="earned">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Earned | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Current -->
                                            <ng-container matColumnDef="current">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Current | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Requested -->
                                            <ng-container matColumnDef="requested">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Requested | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Over -->
                                            <ng-container matColumnDef="over">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Over | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Need -->
                                            <ng-container matColumnDef="need">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Need | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Status -->
                                            <ng-container matColumnDef="status">
                                                <mat-cell *matCellDef="let creditCode">
                                                    {{creditCode.Status}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Courses -->
                                            <ng-container matColumnDef="expandedDetail">
                                                <mat-cell *matCellDef="let creditCode; let p = dataIndex" [attr.colspan]="2"
                                                    style="width:100%;" class="mat-detail-card">

                                                    <!-- Courses Table -->
                                                    <mat-table [dataSource]="creditCode.getTableData(gpFilterParam)"
                                                        class="courseTable" multiTemplateDataRows>

                                                        <!-- Course -->
                                                        <ng-container matColumnDef="course">
                                                            <mat-cell *matCellDef="let course">
                                                                <a *ngIf="currentUser.UserType == 1" (click)="creditCodeOverrideClick(course)">
                                                                    {{course.Course}}
                                                                </a>
                                                                <span *ngIf="currentUser.UserType != 1">
                                                                    {{course.Course}}
                                                                </span>
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Required -->
                                                        <ng-container matColumnDef="required">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Required | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Attempted -->
                                                        <ng-container matColumnDef="attempted">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Attempted | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Earned -->
                                                        <ng-container matColumnDef="earned">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Earned | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Current -->
                                                        <ng-container matColumnDef="current">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Current | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Requested -->
                                                        <ng-container matColumnDef="requested">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Requested | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Over -->
                                                        <ng-container matColumnDef="over">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Over | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Need -->
                                                        <ng-container matColumnDef="need">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Need | gpCreditFormat: gpFilterParam.CreditDecimalPrecision}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Status -->
                                                        <ng-container matColumnDef="status">
                                                            <mat-cell *matCellDef="let course">
                                                                {{course.Status}}
                                                            </mat-cell>
                                                        </ng-container>

                                                        <!-- Row Definitions -->
                                                        <mat-row
                                                            *matRowDef="let course; columns: courseColumns; let q = dataIndex"
                                                            id="planType{{i}}graduationPlan{{j}}subjectArea{{k}}creditCode{{p}}course{{q}}"
                                                            style="overflow: hidden"></mat-row>
                                                    </mat-table>
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Row Definitions -->
                                            <mat-row
                                                *matRowDef="let creditCode; columns: creditCodeColumns; let p = dataIndex"
                                                id="planType{{i}}graduationPlan{{j}}subjectArea{{k}}creditCode{{p}}"
                                                style="overflow: hidden"
                                                (click)="creditCode.getTableData(gpFilterParam).data.length > 0 ? subjectArea.getTableData(gpFilterParam).toggleExpanded(creditCode) : null">
                                            </mat-row>
                                            <mat-row *matRowDef="let creditCode; columns: ['expandedDetail']"
                                                [@detailExpand]="creditCode.getTableData(gpFilterParam).data.length > 0 && subjectArea.getTableData(gpFilterParam).checkExpanded(creditCode) ? 'expanded' : 'collapsed'"
                                                style="overflow: hidden;" class="mat-detail-row"></mat-row>
                                        </mat-table>
                                    </mat-cell>
                                </ng-container>

                                <!-- Row Definitions -->
                                <mat-row *matRowDef="let subjectArea; columns: subjectAreaColumns; let k = dataIndex"
                                    id="planType{{i}}graduationPlan{{j}}subjectArea{{k}}" tabIndex="0"
                                    style="overflow: hidden;"
                                    (click)="subjectArea.getTableData(gpFilterParam).data.length > 0 ? gradPlan.getTableData(gpFilterParam).toggleExpanded(subjectArea) : null">
                                </mat-row>
                                <mat-row *matRowDef="let subjectArea; columns: ['expandedDetail']"
                                    [@detailExpand]="subjectArea.getTableData(gpFilterParam).data.length > 0 && gradPlan.getTableData(gpFilterParam).checkExpanded(subjectArea) ? 'expanded' : 'collapsed'"
                                    style="overflow: hidden;" class="mat-detail-row"></mat-row>
                            </mat-table>
                        </mat-cell>
                    </ng-container>

                    <!-- Row Definitions -->
                    <mat-row *matRowDef="let gradPlan; columns: gradPlanTableColumns; let j = dataIndex"
                        id="planType{{i}}graduationPlan{{j}}" tabIndex="0" style="overflow: hidden;"
                        (click)="gradPlan.getTableData(gpFilterParam).data.length > 0 ? tableData.toggleExpanded(gradPlan) : null">
                    </mat-row>
                    <mat-row *matRowDef="let gradPlan; columns: ['expandedDetail']"
                        [@detailExpand]="gradPlan.getTableData(gpFilterParam).data.length > 0 && tableData.checkExpanded(gradPlan) ? 'expanded' : 'collapsed'"
                        style="overflow: hidden;" class="mat-detail-row"></mat-row>
                </mat-table>

            </div>
        </tyl-kendo-pdf-export>

        <!-- Footer -->
        <div class="flex-footer">
            <div class="flex-footer-left">
                <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons>
                <tyl-button image="filter.png" label="Filter" (clickEvent)="showFilterClick();" *ngIf="!isFiltered">
                </tyl-button>
                <tyl-button image="filter yellow.png" label="Filter" (clickEvent)="showFilterClick();"
                    *ngIf="isFiltered"></tyl-button>
            </div>
            <div class="flex-footer-middle" style="align-items: center">
                <filter-notification [filtered]="isFiltered" (clearFilter)="clearFilterEvent.emit()">
                </filter-notification>
            </div>
            <div class="flex-footer-right" style="margin:15px">
                <tyl-checkbox *ngIf="currentUser.UserType == 1" [(checked)]="gpFilterParam.showAllGP"
                    (change)="refetchData()" translate>Show All Graduation Plans</tyl-checkbox><br>
                <tyl-checkbox [(checked)]="gpFilterParam.notInGP" (change)="refetchData()">
                    <span translate>Show Courses Not In Graduation Plan</span>
                </tyl-checkbox>
            </div>
        </div>

    </div>

    <app-gp-filter *ngIf="showFilter" [clearFilter]="clearFilterEvent" [gpFilterParam]="gpFilterParam"
        (filterChanged)="filterChanged($event)" (closeFilterEvent)="showFilterClick()"
        class="filter-body">
    </app-gp-filter>

</div>
